import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddModulLocatieActivaPayload, IEditModulLocatieActivaPayload, IModulLocatieActiva, IModulLocatieActivaFind } from './module-locatii-active.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModuleLocatiiActiveService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listModuleLocatiiActiveURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleLocatiiActive.list;
    private listDTModuleLocatiiActiveURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleLocatiiActive.listDT;
    private addModulLocatieActivaURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleLocatiiActive.store;
    private updateModulLocatieActivaURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleLocatiiActive.update;
    private deleteModulLocatieActivaURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleLocatiiActive.delete;
    private findByModuleURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleLocatiiActive.findByModule;

    constructor(private http: HttpClient) { }

    listModuleLocatiiActive() {
        return this.http.get<{ errors: boolean; data: IModulLocatieActiva[]; status_code: number }>(
            this.listModuleLocatiiActiveURL
        ).pipe(
            map((response) =>
                response.data.map((item) => ({
                    id: item.id,
                    name: item.locatie_name,
                    id_modul: item.id_modul,
                    id_locatie: item.id_locatie,
                }))
            ),
            catchError((error) => {
                console.error('Error in get locatii active:', error);
                return throwError(error);
            })
        );
    }

    listDTModuleLocatiiActive() {
        return this.http.post(this.listDTModuleLocatiiActiveURL, {});
    }

    addModulLocatieActiva(data: IAddModulLocatieActivaPayload) {
        return this.http.post(this.addModulLocatieActivaURL, data);
    }

    updateModulLocatieActiva(data: IEditModulLocatieActivaPayload) {
        return this.http.put(this.updateModulLocatieActivaURL, data);
    }

    deleteModulLocatieActiva(id: number) {
        return this.http.delete(this.deleteModulLocatieActivaURL + id);
    }

    findByModule(id: number) {
        return this.http.get<{ errors: boolean; data: IModulLocatieActivaFind[]; status_code: number }>(
            this.findByModuleURL + id,
        ).pipe(
            map((response) => response.data),
            catchError((error) => {
                console.error('Error in get locatii active modul:', error);
                return throwError(error);
            })
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
